// extracted by mini-css-extract-plugin
module.exports = {"text-hints":"TextSearch_text-hints__1HDzk","matching-content":"TextSearch_matching-content__2b-zY"};